import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PolicyDocumentTemplateApiModel } from '@app/api/api-models/program-settings/PolicyDocumentTemplateApiModel';
import { BulkCreatePolicyDocumentTemplateApiModel } from '@app/api/api-models/program-settings/BulkCreatePolicyDocumentTemplateApiModel';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class PolicyDocumentTemplatesService {
  public apiUrl = 'policy-document-templates';

  constructor(private readonly http: HttpClientService) {}

  public getList(): Observable<PolicyDocumentTemplateApiModel[]> {
    return this.http.get<PolicyDocumentTemplateApiModel[]>(`${this.apiUrl}`);
  }

  public getById(id: number): Observable<PolicyDocumentTemplateApiModel> {
    return this.http.get<PolicyDocumentTemplateApiModel>(`${this.apiUrl}/${id}`);
  }

  public create(model: PolicyDocumentTemplateApiModel): Observable<PolicyDocumentTemplateApiModel> {
    return this.http.post<PolicyDocumentTemplateApiModel>(`${this.apiUrl}`, model);
  }

  public update(model: PolicyDocumentTemplateApiModel): Observable<PolicyDocumentTemplateApiModel> {
    return this.http.put<PolicyDocumentTemplateApiModel>(`${this.apiUrl}`, model);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  public createBulk(model: BulkCreatePolicyDocumentTemplateApiModel): Observable<PolicyDocumentTemplateApiModel[]> {
    return this.http.post<PolicyDocumentTemplateApiModel[]>(`${this.apiUrl}/bulk`, model);
  }
}
